/**
 * Timestamps arrive in three shapes: ISO from JSON, "YYYY-MM-DD HH:MM:SS.fff+00"
 * from node-postgres (local), and "YYYY-MM-DD HH:MM:SS.fff" in UTC with no zone
 * from the RDS Data API. Normalize all of them. Plain dates (YYYY-MM-DD) are
 * read as midday local time so they never shift a day.
 */
export function parseTs(value: string | null | undefined): Date | null {
  if (!value) return null;
  let s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(`${s}T12:00:00`);
  if (/^\d{4}-\d{2}-\d{2} \d/.test(s)) s = s.replace(" ", "T");
  s = s.replace(/([+-]\d{2})$/, "$1:00");
  if (/T\d{2}:\d{2}/.test(s) && !/(Z|[+-]\d{2}:?\d{2})$/.test(s)) s += "Z";
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}
